import SubscriptionTopicModel from 'cio/models/subscription-topic';
import Model from '@ember-data/model';

export const MAX_NAME_LENGTH = 191;
export const MAX_DESCRIPTION_LENGTH = 200;

// Defines subscription preferences key types
export type SubscriptionPreferences = {
  topics: Record<string, boolean>;
};

export type TopicWithPreference = {
  id: string;
  name: string;
  preference: boolean;
  description?: string;
};

export interface ModelWithSubscriptionTopic extends Model {
  subscriptionTopic: SubscriptionTopicModel | null;
  sendToUnsubscribed: boolean;
  hasDeletedSubscriptionTopic: boolean;
  subscriptionTopicId: string | null;
}

export enum LogoSource {
  Custom = 'custom',
  Account = 'account_settings',
  None = 'none',
}

export interface SerializedSubscriptionCenterSettings {
  background_color: string | null;
  foreground_color: string | null;
  logo_source: LogoSource | null;
  logo_path: string | null;
}

export interface SubscriptionCenterSettings {
  backgroundColor: string | null;
  foregroundColor: string | null;
  logoSource: LogoSource | null;
  logoPath: string | null;
}

export const MOCK_TOPICS = [
  { id: 'mock_1', name: 'Topic', description: 'A short description that describes what this topic is about' },
  { id: 'mock_2', name: 'Topic', description: 'A short description that describes what this topic is about' },
];

export enum SubscriptionCenterNavTabs {
  GlobalUnsubscribe = 'global_unsubscribe',
  Topics = 'topics',
}

export enum SetPreferencesType {
  Pending = 'pending',
  All = 'all',
  Completed = 'completed',
}

export enum SetPreferencesSearchType {
  Campaign = 'campaign',
  Newsletter = 'newsletter',
  Broadcast = 'broadcast',
}

export enum SendToUnsubscribedValues {
  AllSubscribed = 'all_subscribed',
  AllSubscribedAndUnsubscribed = 'all_subscribed_and_unsubscribed',
}
